<div class="checkout-group js-order-review">
  <div class="checkout-group-title">
    {{ 'checkout.group.orderReview.title' | cxTranslate }}
  </div>
  <div class="checkout-group-body" [ngClass]="activeLanguage$ | async">
    <app-dynamic-form
      (formGroupEmit)="updateFormGroup($event)"
      (formModelEmit)="updateFormModel($event)"
      [formGroupId]="'CHECKOUT_ORDER_REVIEW'"
      [emitOnInit]="true"
      [static]="false"
      [activeLanguage]="activeLanguage$ | async"
    ></app-dynamic-form>
  </div>
</div>
